import React from 'react';

export class RejectedRequestsPage extends React.Component<{}> {
    public render() {
        return (
            <div>Rejected Requests Page - Coming Soon.</div>
        );
    }
}